<template>
  <div class="image-container">
    <img src="@/assets/img/wx.png" alt="加我" class="center-image">
  </div>
</template>

<script>
export default {
  name: 'WX'
}
</script>

<style scoped>
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.center-image {
  max-width: 100%;
  max-height: 100%;
}
</style>